<template>
  <section v-if='kirby.pages.stories'>
    <summary v-html='kirby.pages.stories.strings.kiosk' />
    <tags id='Featured-Tags' :tags='kirby.pages.stories.strings.featured_tags.split(", ")' @selectTag='selectTag($event)' :select='selectedTag' />
    <tags :tags='tags' :filtered='kirby.pages.stories.strings.featured_tags.split(", ")' @selectTag='selectTag($event)' :select='selectedTag' />
    <PlayList :stories='yaml(kirby.pages.stories.strings.kioskstories)' :tags.sync='tags' :filtered='selectedTag' />
  </section>
</template>

<script>
import mixins from '.././mixins.js';
export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  data: function(){
    return {
      tags: [],
      selectedTag: false
    }
  },
  created: function(){
    this.selectedTag = window.location.hash.substring(1).replaceAll('_',' ').replace('ambersand','&');
    console.log(this.selectedTag);
  },
  methods: {
    selectTag: function(tag){
      this.selectedTag = (this.selectedTag == tag) ? '' : tag;
      window.location.hash = tag.replaceAll(' ', '_').replace('&', 'ambersand')
    }
  }
}
</script>

<style scoped>
  summary::v-deep(h1) {
    margin-top: -0.25em;
    padding-right: 0.5em;
  }

  summary {
    padding-top: 1rem;
    padding-bottom: 5rem;
    column-count: 2;
    column-gap: 2rem;
  }
</style>
